import { Empreendimento } from "../../../../incorporacao/domain/models/empreendimento";
import { IGetEmpreendimentoByIdObraUseCase } from "../../../presentation/useCases/read/get_empreendimento_by_id_obra_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetEmpreendimentoByIdObraUseCase
 */

export class GetEmpreendimentoByIdObraUseCase implements IGetEmpreendimentoByIdObraUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getEmpreendimentoByIdObra(
    idObra: number | undefined,
  ): Promise<Empreendimento> {
    if (idObra === undefined) throw new Error("Falha ao recuperar id da obra!");
    const response = await this.repository.getEmpreendimentoByIdObra(idObra);
    if (response === null) throw new Error('Falha ao buscar empreendimento!');
    return response;
  }
}
